import React from 'react';
import BaseContent from 'components/BaseContent';
import style from './index.less';
import {Button,Layout} from 'antd';
import {toUrl} from 'utils/tool.js';

const EmptyPage  = function(props) {
    const jump = ()=>{
        toUrl('/pages');
    };
    return(
        <Layout style={{position: 'relative'}}>
            <div className={style.box}>
                <BaseContent style={{ position: 'relative',height:'100%',marginTop:0}}>
                    <div className={style.main}>
                        <img width='180' src={require('../../image/no-data.png')} alt=""/>
                        <p style={{fontSize:'16px',color:'#9c9c9c',width:'100%',textAlign:'center'}}>{props.title}</p>
                        {props.hasIndexButton?<Button type="primary" onClick={jump}>Back to Homepage</Button>:null}
                    </div>
                </BaseContent>
            </div>
        </Layout>
    );
};

export default EmptyPage;



// WEBPACK FOOTER //
// ./src/components/EmptyPage/index.js